import { OpenPatientService } from "@/common/api.service";
import { FETCH_OPEN_PATIENT_DATA, SEND_SURVEY_DATA,ACKNOWLEDGE_VIDEO,VALIDATE_PATIENT, FETCH_PATIENT_VIDEOS ,CREATE_OPEN_PATIENT_DATA,RESET_STATE } from "./actions.type";
import { SET_OPEN_PATIENT_DATA, SET_OPEN_PATIENT_ERROR, SET_OPEN_PATIENT_VIDEOS_DATA,STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    openpatientdata: [],
    openpatientvideosdata:[],
    openpatientserror: [],
  }
};

export const state = initialState();

const actions ={
    async [FETCH_OPEN_PATIENT_DATA](context, slug){
        return await OpenPatientService.get(slug).then( response => {
          context.commit(SET_OPEN_PATIENT_DATA, response.data)
          return response.data
        }).catch(( { response}) =>{
          context.commit(SET_OPEN_PATIENT_ERROR, response.data.errorMessage)
          return response
        })
      },

    async [CREATE_OPEN_PATIENT_DATA](context, slug) {
        return await OpenPatientService.create(slug.slug, slug.params).then((response) => {
          return response
        }).catch(({response})=>{
          context.commit(SET_OPEN_PATIENT_ERROR, response.data.errorMessage)
          return response
        })
      },

      async [SEND_SURVEY_DATA](context, slug) {
        return await OpenPatientService.create(slug.slug, slug.params).then((response) => {
          return response
        }).catch(({response})=>{
          context.commit(SET_OPEN_PATIENT_ERROR, response.data.errorMessage)
          return response
        })
      },


      async [VALIDATE_PATIENT](context,slug) {
        return await OpenPatientService.create(slug.slug,slug.params).then((response) =>{
          return response
        }).catch(({response}) =>{
          context.commit(SET_OPEN_PATIENT_ERROR, response.data.errorMessage)
          return response
        })
      },
      async [FETCH_PATIENT_VIDEOS](context,slug) {
        return await OpenPatientService.get(slug).then((response)=>{
          context.commit(SET_OPEN_PATIENT_VIDEOS_DATA, response.data)
          return response
        }).catch(({response}) =>{
          context.commit(SET_OPEN_PATIENT_ERROR, response.data.errorMessage)
          return response
        })
      },
      async [ACKNOWLEDGE_VIDEO](context,slug) {
        return await OpenPatientService.create(slug.slug,slug.params).then((resp)=>{
          return resp
        }).catch(({response}) =>{
          context.commit(SET_OPEN_PATIENT_ERROR, response.data.errorMessage)
          return response
        })
      },

      [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
      }

}

const getters = {
  
    openpatientdata(state) {
      return state.openpatientdata;
    },
    openpatientvideosdata(state){
      return state.openpatientvideosdata;
    }

  }


const mutations = {
    [SET_OPEN_PATIENT_DATA](state, patient) {
        state.openpatientserror = patient
    },
    [SET_OPEN_PATIENT_VIDEOS_DATA] (state,videosdata){
      state.openpatientvideosdata = videosdata
    },
    [SET_OPEN_PATIENT_ERROR](state, error) {
      state.openpatientserror = error
    },
    [STATE_RESET](state) {
      Object.assign(state,initialState())
    }
  
  }


export default {
    state,
    getters,
    actions,
    mutations
};